import { API } from "../../../config";
import CONSTANTS from "../../../constants/constants";
import LoginModel from "../../../models/SellerLogin/LoginModel";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { serverAPIPath,mockAPIPath} from "../config/apiPath";


class DemoUserService {

    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read(),"accept-language":process.env.REACT_APP_LANGUAGE,
            "demo-user": CONSTANTS.DEMO_USER_CONSTANTS 
        };
    }
    
    async demoUserlogin() {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ? 
            await new AxiosUtils(mockAPIPath.LOGIN, this.payload).getNew() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.LOGIN}`, this.payload,this.headers).post();
        let userDetails: LoginModel = new LoginModel();
        if(response?.data?.success==true) {
            userDetails = LoginModel.parseJson(response?.data?.data);
            return userDetails;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        } 

    }

    async logout() {
        await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.LOGOUT}`, {}, this.headers).post();
        window.close();
        new Cookies("access-token").delete();
    }

}

export default DemoUserService;